<ng-container *ngIf="control">
	<div class="form-check">
		<input
			#input
			[formControl]="control"
			type="checkbox"
			class="form-check-input"
			[id]="formControlName"
			(change)="onChangeValue(input)"
		/>
		<label
			[for]="formControlName"
			class="form-label"
			[tooltip]="tooltipRef"
			[placement]="tooltipPlacement"
		>
			{{ labelText }}
		</label>
	</div>
</ng-container>
